import { render, staticRenderFns } from "./TributeTemplateTable.vue?vue&type=template&id=054e1796&scoped=true"
import script from "./TributeTemplateTable.vue?vue&type=script&lang=js"
export * from "./TributeTemplateTable.vue?vue&type=script&lang=js"
import style0 from "./TributeTemplateTable.vue?vue&type=style&index=0&id=054e1796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e1796",
  null
  
)

export default component.exports